export const T = {
  en_GB: {
    startQuiz: "Start Quiz",
    retryQuiz: "Try Again",
    passed: "Passed",
    notPassed: "Not passed",
    notStarted: "Not started",
    externalTestConfirmedBy: (name: string) => `External test confirmed by ${name}`,
    overrideReason: (reason: string) => `Reason: ${reason}`,
    attemptsRemaining: (n: number) => `${n} attempts remaining`,
    oneAttemptRemaining: "1 attempt remaining",
    retryAvailableOn: (date: string) => `You can try again from ${date}.`,
    noAttemptsRemaining: "No attempts remaining.",
    incompleteMessage: "This quiz must be passed before the flow can be submitted.",
    noQuiz: "This quiz has no questions yet.",
    override: "Override",
    recordedExternally: "Recorded externally",
    // repNoteViaMember is a template filled by `fillRepresentativeTemplate` (@repo/shared).
    repNote: (name: string) => `The quiz is taken by ${name}, who acts on behalf of the client.`,
    repNoteViaMember:
      "The quiz is taken by {name} ({role}), on behalf of {member}, who acts for the group.",
    repGeneric: "the client's representative",
    memberCountPassed: (passed: number, total: number) => `${passed} of ${total} passed`,
    expandMembers: "Show members",
    collapseMembers: "Hide members",
    expandRepresentatives: "Show representatives",
    collapseRepresentatives: "Hide representatives",
    repListNote:
      "Representatives: several people act for this client and each takes the quiz for themselves. It counts as passed only when all of them pass.",
  },
  nb_NO: {
    startQuiz: "Start quiz",
    retryQuiz: "Prøv igjen",
    passed: "Bestått",
    notPassed: "Ikke bestått",
    notStarted: "Ikke startet",
    externalTestConfirmedBy: (name: string) => `Ekstern test bekreftet av ${name}`,
    overrideReason: (reason: string) => `Begrunnelse: ${reason}`,
    attemptsRemaining: (n: number) => `${n} forsøk igjen`,
    oneAttemptRemaining: "1 forsøk igjen",
    retryAvailableOn: (date: string) => `Du kan prøve igjen fra ${date}.`,
    noAttemptsRemaining: "Ingen forsøk igjen.",
    incompleteMessage: "Denne quizen må bestås før flyten kan sendes inn.",
    noQuiz: "Denne quizen har ingen spørsmål ennå.",
    override: "Overstyr",
    recordedExternally: "Registrert eksternt",
    repNote: (name: string) => `Quizen tas av ${name}, som handler på vegne av kunden.`,
    repNoteViaMember:
      "Quizen tas av {name} ({role}), på vegne av {member}, som handler for gruppen.",
    repGeneric: "kundens representant",
    memberCountPassed: (passed: number, total: number) => `${passed} av ${total} bestått`,
    expandMembers: "Vis medlemmer",
    collapseMembers: "Skjul medlemmer",
    expandRepresentatives: "Vis representanter",
    collapseRepresentatives: "Skjul representanter",
    repListNote:
      "Representanter: flere personer handler for denne kunden, og hver av dem tar quizen for seg selv. Den teller som bestått bare når alle har bestått.",
  },
} as const;
